import React, { useEffect, useState, useContext } from "react";
import {fetchUserFinLogs, markFinLogsAsRead, markLogsAsRead} from "../../../http/userLogAPI";
import { Context } from "../../../index";
import {Modal, Spinner, Table, Badge, Button} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import {ADD_FUNDS_TO_USD_BALANCE_ROUTE, LIBRARY_ROUTE} from "../../../utils/consts";

const UserFinancialLogsModal = ({ show, handleClose }) => {
    const { user } = useContext(Context);
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [markingRead, setMarkingRead] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (show) {
            fetchUserFinLogs(user.user.id)
                .then(data => setLogs(data))
                .finally(() => setLoading(false));
        }
    }, [show, user.user.id]);

    // Отметить все логи как прочитанные
    const handleMarkAsRead = async () => {
        setMarkingRead(true);
        await markFinLogsAsRead(user.user.id);
        setLogs(logs.map(log => ({ ...log, is_read: true }))); // Обновляем состояние
        setMarkingRead(false);

    };

    const handleMarkAsReadAndClose = async () => {
        setMarkingRead(true);
        await markFinLogsAsRead(user.user.id);
        setLogs(logs.map(log => ({ ...log, is_read: true }))); // Обновляем состояние
        setMarkingRead(false);
        handleClose();
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg" centered scrollable>
            <Modal.Header closeButton className="position-relative">
                <Modal.Title className="text-muted">Financial Logs:</Modal.Title>
                <div className="position-absolute top-50 start-50 translate-middle">
                    <Button
                        variant="outline-success"
                        onClick={handleMarkAsRead}
                        disabled={markingRead || logs.length === 0}
                        className="btn-sm btn-outline-success"
                    >
                        Mark as Read
                    </Button>
                    <Button
                        variant="outline-success"
                        onClick={handleMarkAsReadAndClose}
                        disabled={markingRead || logs.length === 0}
                        className="btn-sm btn-outline-success ms-3"
                    >
                        Mark & Close
                    </Button>
                    <Button variant="success" onClick={() => {navigate(ADD_FUNDS_TO_USD_BALANCE_ROUTE); handleClose();}}
                            className="btn-sm btn-success ms-3"
                            >
                        Add Funds
                    </Button>

                </div>
            </Modal.Header>
            <Modal.Body>
                {loading ? (
                    <div className="text-center">
                        <Spinner animation="border" />
                    </div>
                ) : logs.length > 0 ? (
                    <Table bordered hover size="sm" striped className="mt-1">
                        <thead>
                        <tr className="bg-secondary text-center bg-opacity-50 text-sm">
                            <th className="small text-muted">Amount:</th>
                            <th className="small text-muted">Balance:</th>
                            <th className="small text-muted">Description:</th>
                            <th className="small text-muted">Date:</th>
                            <th className="small text-muted">Status:</th>
                        </tr>
                        </thead>
                        <tbody>
                        {logs.slice(0, 50).map((log) => (
                            <tr key={log.id} className="small fst-italic">
                                <td className="text-center small text-success fw-bold" style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                    {Number(log.subtotal_amount) === 0
                                        ? 'No change'
                                        : `${log.subtotal_amount > 0 ? '+' : log.subtotal_amount < 0 ? '-' : ''}$${Math.abs(log.subtotal_amount).toFixed(2)}`}
                                </td>
                                <td className="text-center small" style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                    ${log.lr_balance_state.toFixed(2)}
                                </td>
                                <td className="small" style={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    maxWidth: "650px",
                                    width: "650px"
                                }}>
                                    {log.description}
                                </td>
                                <td className="text-center small text-muted" style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                    {new Date(log.log_date).toLocaleDateString('en-GB', {
                                        day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false,
                                    })}
                                </td>
                                <td className="text-center align-items-center small" style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                    {!log.is_read ? <Badge bg="success">New</Badge> : <span className="text-muted">Read</span>}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                ) : (
                    <p className="text-center text-muted">No Financial Logs</p>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="success" onClick={handleMarkAsReadAndClose}
                        className="btn-sm"
                        disabled={markingRead || logs.length === 0}>
                    Mark All as Read and Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default UserFinancialLogsModal;
